import { render, staticRenderFns } from "./BookingDetail.vue?vue&type=template&id=0e42ce29"
import script from "./BookingDetail.vue?vue&type=script&lang=ts"
export * from "./BookingDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports